import {
  ProductsApiErrorCodes,
  ProductsApiErrorResponse,
  ProductsApiException,
} from '@kotipizzagroup/kotipizza-products-api-client';

const productsApiErrorMessages: Record<ProductsApiErrorCodes, string> = {
  [ProductsApiErrorCodes.UnknownError]: 'Virhe. Yritä myöhemmin uudelleen.',
  [ProductsApiErrorCodes.ValidationError]: 'Virhe pyynnön validoinnissa. Otathan yhteyttä verkkokauppa-tiimiin.',
};

export function isProductsApiErrorResponse(obj: unknown): obj is ProductsApiErrorResponse {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  const maybe = obj as Partial<ProductsApiErrorResponse>;

  const isValidErrorCode = Object.values(ProductsApiErrorCodes).includes(maybe.errorCode as ProductsApiErrorCodes);
  const isValidErrorData = Array.isArray(maybe.errorData);
  const isValidErrorMessage =
    maybe.errorMessage === undefined || maybe.errorMessage === null || typeof maybe.errorMessage === 'string';

  return isValidErrorCode && isValidErrorData && isValidErrorMessage;
}

export const getProductsApiError = (error: unknown): ProductsApiError => {
  if (error instanceof ProductsApiError) return error;

  if (ProductsApiException.isProductsApiException(error)) {
    error = error.response;
  }

  if (!isProductsApiErrorResponse(error)) {
    return new ProductsApiError(
      productsApiErrorMessages[ProductsApiErrorCodes.UnknownError],
      ProductsApiErrorCodes.UnknownError
    );
  }

  return new ProductsApiError(productsApiErrorMessages[error.errorCode], error.errorCode);
};

export class ProductsApiError extends Error {
  public errorCode: ProductsApiErrorCodes | null;
  constructor(errorMessage: string, errorCode: ProductsApiErrorCodes | null) {
    super(errorMessage);
    this.errorCode = errorCode;
  }
}
